module.exports = __webpack_public_path__ + "img/active-music-nav-title.png.9a502b6c.png";